export const OAUTH_CLIENT_SHOW_TABS = ['general', 'tokens'] as const;
export type OAuthClientShowTab = (typeof OAUTH_CLIENT_SHOW_TABS)[number];
export const OAUTH_CLIENT_DEFAULT_TAB: OAuthClientShowTab = 'general';
